/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationServicesAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  BUTTON_ADD_SERVICE = 'button-add-service',
  CONTEXTUAL_BAR_1 = 'contextual-bar-1',
  FETCH_LIST = 'fetch-list',
  FETCH_ORIGIN = 'fetch-origin',
  FETCH_PENDENCIES = 'fetch-pendencies',
  FETCH_SERVICE = 'fetch-service',
  FIELD_0 = 'field-0',
  FIELD_CODE = 'field-code',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_NR_SEQUENCE_LIST = 'field-nrSequence-list',
  FIELD_ORIGIN = 'field-origin',
  FIELD_PROCEDURE = 'field-procedure',
  FIELD_PROCEDURE_LIST = 'field-procedure-list',
  FIELD_SERVICE_VALUE_LIST = 'field-service-value-list',
  FIELD_VALUE_SERVICE = 'field-value-service',
  FILTER_0 = 'filter-0',
  FILTERED_LIST_0 = 'filtered-list-0',
  FORM_0 = 'form-0',
  FORM_SERVICE = 'form-service',
  INPUT_1 = 'input-1',
  INPUT_CODE = 'input-code',
  INPUT_DESCRIPTION = 'input-description',
  INPUT_LOCATOR = 'input-locator',
  INPUT_NR_SEQUENCE_LIST = 'input-nrSequence-list',
  LOCATOR_FIELD_CD_PROCEDURE = 'locator-field-cdProcedure',
  LOCATOR_PROCEDURE = 'locator-procedure',
  MAPPER_10 = 'mapper-10',
  MAPPER_ORIGIN = 'mapper-origin',
  MODAL_ADD_NEW = 'modal-add-new',
  MY_DATA_CARD = 'my-data-card',
  MY_DATA_DECK = 'my-data-deck',
  PANEL_0 = 'panel-0',
  PANEL_MODAL = 'panel-modal',
  PANEL_PENDENCIES = 'panel-pendencies',
  PANEL_SERVICE = 'panel-service',
  TEXT_3_LIST = 'text-3-list',
  TEXT_6_LIST = 'text-6-list',
  TEXT_ORIGIN = 'text-origin',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { ProviderAccreditationServicesAliases };
